import { gql } from '@apollo/client';

export const FETCH_USER_RELATED_ENTITIES = (permissions: string[]) => gql`
  query fetchUserRelatedEntities($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        type
        state
        ${permissions.includes('read:client_low_risk_pii') ? 'phone primaryEmail firstName middleName lastName' : ''}
        entityName
        relatedEntities {
          relation
          entity {
            id type state
            ${permissions.includes('read:client_low_risk_pii') ? 'phone primaryEmail firstName middleName lastName' : ''}
            entityName
          }
        }
      }
    }
  }
`;

export const UPDATE_USER_RELATED_ENTITIES = gql`
  mutation updateUserRelatedEntities(
    $userId: ID!
    $relatedEntities: [RelatedEntityInput]
  ) {
    updateUser(input: { userId: $userId, relatedEntities: $relatedEntities }) {
      user {
        id
      }
    }
  }
`;
